import { MetadataDashboardTemplate } from "@/components/Templates/MetadataDashboardTemplate";
import { useScopeParams } from "@/hooks/useScopeParams";

type Props = { siteId: string };

export default function ProtocolDeviationsTab({ siteId }: Props) {
  const { id } = useScopeParams();
  return (
    <MetadataDashboardTemplate
      type="protocol_deviations_subjects"
      siteId={siteId}
      selectionIdentifierColumn="subject"
      constants={{
        wikiLink: "/wiki/guides/exploration-sites-protocol-deviations",
        idLink: (subjectId: string) =>
          `/${id}/subjects/overview/${subjectId}/protocol-deviations`,
      }}
    />
  );
}
